import { standardQuerySerializer } from './serializers';
import { applyQueryConfig, makeCancelable, ServiceHandler } from '../utils';
import { fetchServiceParamsMapping } from '../console/activity/activityServiceMappings';

const fetchActivityDetailsHandler = makeCancelable(
  ServiceHandler({
    url: '/api/activity/v1/search',
    paramsSerializer: (params) =>
      standardQuerySerializer(
        applyQueryConfig(fetchServiceParamsMapping, params)
      ),
  })
);
export const fetchActivityDetails = (params: Record<string, unknown> = {}) =>
  fetchActivityDetailsHandler({ params });

/** The raw events of an account's activity log: the broker timeline dates a row's stages from their types and times. */
export const getAccountStageEvents = ServiceHandler({
  url: '/api/activity/v1/search',
});

const fetchActivityAggregationHandler = makeCancelable(
  ServiceHandler({
    url: '/api/activity/v1/aggregateEvents',
    paramsSerializer: (params) =>
      standardQuerySerializer(
        applyQueryConfig(fetchServiceParamsMapping, params)
      ),
  })
);
export const fetchActivityAggregation = (
  params: Record<string, unknown> = {}
) => fetchActivityAggregationHandler({ params });
